export default {
  KKDAY_REPORT_TRANSACTION_SEARCH_TYPE: {
    YESTERDAY: '01',
    THIS_MONTH: '02',
    LAST_MONTH: '03',
    DATE_RANGE: '04'
  },
  PRODUCT_COMMISSION_SETTING: {
    VALUE_ALL: '*'
  }
}
